import "./accordion.scss";

function ServicesAccordion({ category, isOpen, onToggle }) {
  return (
    <div className={`accordion ${isOpen ? "open" : ""}`}>
      <div className={`accordion-header ${isOpen ? "active" : ""}`} onClick={onToggle}>
        <span>{category.name}</span>
        <span className={`arrow-accordion ${isOpen ? "open" : ""}`}>▼</span>
      </div>

      <div className={`accordion-body ${isOpen ? "open" : ""}`}>
        {category.services.map((service) => (
          <div key={service.id} className="service-row">
            <div>
              <p className="service-name">{service.name}</p>
              {service.description && (
                <p className="service-description">{service.description}</p>
              )}
            </div>

            <p className="service-price">od {service.price} zł</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServicesAccordion;
